import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './MultipleChoiceComponent.css';
import { Progress } from 'reactstrap';
import { QuestionType } from '../../Utils/Constants';
import { getTrimString } from '../../Utils/StringUtils';
import { UncontrolledTooltip } from 'reactstrap';

class MultipleChoiceComponent extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    qAndAInfo: PropTypes.shape({
      question: PropTypes.string.isRequired,
      questionType: PropTypes.string.isRequired,
      dateAsked: PropTypes.string,
      numberOfResponses: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      responses: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          answererEmails: PropTypes.array,
          numberOfResponses: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
      ).isRequired,
      totalAttendees: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      uniqueRegistrantEmailsCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      totalQuestions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      currentQuestionIndex: PropTypes.number.isRequired
    }).isRequired
  };

  render() {
    const qAndAInfo = this.props.qAndAInfo;
    const isBig = this.props.isBig;
    const { t } = this.context;
    return (
      <div className="qAndAHorizontal">
        <div className="qAndACard">
          <div className="qAndAHeader">
            <div>
              <span className="qAndACount">
                {t('engagement.questionsCount', {
                  currentQuestionIndex: qAndAInfo.currentQuestionIndex,
                  totalQuestions: qAndAInfo.totalQuestions
                })}
              </span>
              {isBig && <span> {qAndAInfo.question} </span>}
            </div>
            {!qAndAInfo.uniqueRegistrantEmailsCount && (
              <div>
                {t('engagement.attendeesRespondedCount', {
                  numberOfAttendeesResponded: qAndAInfo.numberOfResponses,
                  totalAttendees: qAndAInfo.totalAttendees
                })}
              </div>
            )}
            {qAndAInfo.uniqueRegistrantEmailsCount && (
              <div>
                {t('engagement.numberOfRegistrantsResponded', {
                  numberOfRegistrantsResponded: qAndAInfo.uniqueRegistrantEmailsCount
                })}
              </div>
            )}
          </div>
          <div className="qAndASubHeader">
            {!isBig && <div className="mobileQuestionAttribute"> {qAndAInfo.question} </div>}
            <div className="mobileQuestionTypeAttribute">{`${
              qAndAInfo.questionType && qAndAInfo.questionType === QuestionType.SINGLE_CHOICE
                ? t('engagement.multipleChoiceQuestion')
                : t('engagement.multipleChoiceMultipleAnswer')
            }`}</div>
          </div>

          {this.displayProgressBar(qAndAInfo)}
        </div>
      </div>
    );
  }

  displayProgressBar = qAndAInfo => {
    const { t } = this.context;
    return qAndAInfo.responses.map((item, index) => (
      <div className="progressbar" key={index}>
        <div className="percentPadding">{Math.round(item.percentage * 100) / 100}%</div>
        <Progress
          value={item.percentage}
          barClassName="customProgressBar"
          id={`toolTipProgressBar${qAndAInfo.dateAsked}${qAndAInfo.currentQuestionIndex}${index}`}>
          {getTrimString(item.text, 69)}
        </Progress>
        <div className="responsePadding">
          {t('engagement.numberOfResponses', { numberOfResponses: item.numberOfResponses })}
        </div>
        {item.text.length >= 69 && (
          <UncontrolledTooltip
            placement="top"
            target={`toolTipProgressBar${qAndAInfo.dateAsked}${qAndAInfo.currentQuestionIndex}${index}`}
            className="tooltip-white"
            innerClassName="tooltipInner">
            {item.text}
          </UncontrolledTooltip>
        )}
      </div>
    ));
  };
}

export default MultipleChoiceComponent;



// WEBPACK FOOTER //
// ./src/Components/MultipleChoiceComponent/MultipleChoiceComponent.js